import { useAtomValue } from "jotai";
import type { Dispatch, SetStateAction } from "react";
import { useEffect } from "react";
import type { YouTubePlayer } from "youtube-player/dist/types";

import { scmpYouTubeVideoAtom } from "~/components/scmp-youtube-video/atoms";
import { AutoplayMode } from "~/components/scmp-youtube-video/scmp-youtube-video-player/enums";

/**
 * For ensure there is only one player play the video
 */
export const useOnlyOnePlayerEffect = (
  uniqueVideoId: string,
  player: OrUndefined<YouTubePlayer>,
  setAutoplayMode: Dispatch<SetStateAction<AutoplayMode>>,
) => {
  const scmpYouTubeVideo = useAtomValue(scmpYouTubeVideoAtom);
  useEffect(() => {
    if (!scmpYouTubeVideo.playingId || !player) return;
    else if (uniqueVideoId !== scmpYouTubeVideo.playingId) {
      // Need to set it to be autoplay pausing for preventing set manualPaused to true accidentally
      setAutoplayMode(AutoplayMode.Pausing);
      void player.pauseVideo();
    }
  }, [player, scmpYouTubeVideo, setAutoplayMode, uniqueVideoId]);

  return {
    uniqueVideoId,
  };
};
